'use strict';

// Customized for this use-case
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
const isObject = x => typeof x === 'object' && x !== null && !(x instanceof RegExp) && !(x instanceof Error) && !(x instanceof Date);
module.exports = function mapObj(object, fn, options, seen) {
  options = Object.assign({
    deep: false,
    target: {}
  }, options);
  seen = seen || new WeakMap();
  if (seen.has(object)) {
    return seen.get(object);
  }
  seen.set(object, options.target);
  const _options = options,
    target = _options.target;
  delete options.target;
  const mapArray = array => array.map(x => isObject(x) ? mapObj(x, fn, options, seen) : x);
  if (Array.isArray(object)) {
    return mapArray(object);
  }

  /// TODO: Use `Object.entries()` when targeting Node.js 8
  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    const key = _Object$keys[_i];
    const value = object[key];
    let _fn = fn(key, value, object),
      _fn2 = _slicedToArray(_fn, 2),
      newKey = _fn2[0],
      newValue = _fn2[1];
    if (options.deep && isObject(newValue)) {
      newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObj(newValue, fn, options, seen);
    }
    target[newKey] = newValue;
  }
  return target;
};